import { apiRequest } from "../util/apiUtils";

export const transactionList = async (params) => {
  try {
    const res = await apiRequest("get", `transaction/transaction-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const donorTransactionList = async (params) => {
  try {
    const res = await apiRequest("get", `transaction/list-user`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `transaction/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `transaction/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const transactionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `transaction/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
